// extracted by mini-css-extract-plugin
module.exports = {"button":"LoadingButton_button__mOzuw","circularProgress":"LoadingButton_circularProgress__3NTgR"};